import { gql } from '../../../__generated__/graphql/catalog'
import { GetCollectionQueryVariables } from '../../../__generated__/graphql/catalog/graphql'

export const sanitizeFilterConfig = (
  filterConfig: GetCollectionQueryVariables['filterConfig']
): GetCollectionQueryVariables['filterConfig'] => {
  const filters =
    filterConfig?.filters.map(filter => {
      return {
        name: filter.name,
        displayName: filter.displayName,
        crawlable: filter.crawlable,
        displayType: filter.displayType,
      }
    }) ?? []
  return {
    filters,
  }
}

export const filterKeysFromFilterConfig = (
  filterConfig: GetCollectionQueryVariables['filterConfig']
): NonNullable<GetCollectionQueryVariables['filterKeys']> => {
  const filters = filterConfig?.filters ?? []
  return filters.map(filter => {
    return filter.name
  })
}

export const GET_COLLECTION = gql(`
  query GetCollection(
    $after: String
    $first: Int!
    $nextPageDataOnly: Boolean!
    $collectionColorScope: CollectionColorScope!
    $filterConfig: FilterConfigInput
    $filterKeys: [String!]
    $selectedFilters: [CollectionItemFilterInput!]
    $collectionHandle: String!
    $grouping: CollectionItemGrouping
  ) {
    collection: optimizedCollection(handle: $collectionHandle, colorScope: $collectionColorScope, filterConfig: $filterConfig) {
      id
      handle
      colors @skip(if: $nextPageDataOnly) {
        name
        hexCodes
        swatchUrl
      }
      filters(filterKeys: $filterKeys, selectedFilters: $selectedFilters) @skip(if: $nextPageDataOnly) {
        ...CollectionProductFilter 
      }
      items(selectedFilters: $selectedFilters, first: $first, after: $after, grouping: $grouping) {
        ...CollectionItemsConnection,
        nodes {
          ...CollectionItemProduct
        }
      }
    }
  }
`)
